import React from 'react';
export function TopBadge() {
  return <div className="w-full bg-violet-rich/30 border-b border-gold/20 py-2 sm:py-3" data-id="element-292">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-293">
        <p className="text-center text-[10px] sm:text-sm text-gold/90 tracking-wide" data-id="element-294">
          ● Sistema N°1 en Argentina · Descarga inmediata · +4.800 emprendedoras
          activas
        </p>
      </div>
    </div>;
}